import "./Member.css";

function Member(props)
{
    return(
        <div className = "member">
            <img src = { props["image"] } />
            &emsp;
            <div className = "text_details">
                <h1>{ props["name"] }</h1>
                <h2>{ props["email"] }</h2>
            </div>
            <div className = "status"></div>
        </div>
    )
}

export default Member;